import React from 'react';
import style from './AddButton.module.css';

const AddButton = () => {
	return (
		<div>
			<button className={style.buttonStyle}>+</button>
		</div>
	);
};

export default AddButton;
